import SpeciesCreator from "../../componants/species/SpeciesCreator";

function AddSpecies(){
    return(
        <SpeciesCreator>
            
        </SpeciesCreator>
    )
}

export default AddSpecies;